/* eslint-disable no-param-reassign */
 
const $ = require('lib/jquery')
const keycode = require('lib/keycode')
const log = require('log').create('enter')

const Enter = {
    listening: false,
    stack: [],
    handlers: {},
    focushandlers: {},

    listen(id, handler, focushandler) {
        if (! id || ! $.isFunction(handler)) return log.error('Enter.listen requires an id and a handler function')
        // log('Enter: adding '+id);
        this.unlisten(id)
        this.stack.unshift(id)
        this.handlers[id] = handler
        if ($.isFunction(focushandler)) this.focushandlers[id] = focushandler
        // log(this.stack);
        this._on()

    },
    unlisten(id) {
        // remove a dialog from the stack
        // log('Enter: removing '+id);
        const index = $.inArray(id, this.stack)
        if (index > -1) this.stack.splice(index, 1)
        delete this.handlers[id]
        delete this.focushandlers[id]

        if (index === 0 && this.stack.length) {
            // some other listener is now topmost, see if they'd like to be notified
            id = this.stack[0]
            if (id && this.focushandlers[id]) {
                this.focushandlers[id]()
            }
        }

        // log(this.stack);
        this._off()
    },
    trigger() {
        // trigger most recently added listener
        const id = this.stack[0]
        // log('trigger', id);
        if (id && this.handlers[id]) {
            this.handlers[id]()
        }
    },

    validateKey(e) {
        if (e.which === keycode.ENTER) return true
        return false
    },

    _on() {
        if (this.listening) return
        $(window).on('keyup.enter', (e) => {
            if (Enter.validateKey(e)) {
                Enter.trigger()
            }
        })
        this.listening = true
    },
    _off() {
        if (! this.stack.length) {
            $(window).off('keyup.enter')
            this.listening = false
        }
    },

}

module.exports = Enter
